import  React from 'react';
import PropTypes from "prop-types";


class Percent extends React.Component {
  render(){
    const toFixed = this.props.toFixed || 2;

    return <React.Fragment>{((this.props.number || 0) * 100.0).toFixed(toFixed)}%</React.Fragment>;
  }
}
export default Percent;

Percent.propTypes = {
  number: PropTypes.number
};